import { Pipe, PipeTransform } from '@angular/core';
import { PaymentMethod } from 'src/app/core/model/Order.model';

@Pipe({
  name: 'paymentMethod'
})
export class PaymentMethodPipe implements PipeTransform {
  transform(paymentMethod: any, args?: any): any {
    switch (paymentMethod) {
      case 'paypal':
        return 'Carta di Credito/Paypal';

      case 'cash':
        return 'Contanti';

      case 'transfer':
        return 'Bonifico Bancario';

      default:
        return paymentMethod;
    }
  }
}
